export default __webpack_public_path__ + "static/media/help9.d1ede8d8.svg";